import {
  PopupPortal
} from "./chunk-UZDY5GA7.mjs";

// lib/components/popup/popup/popup.tsx
import classNames from "classnames";
import { useEffect, useState } from "react";
import { usePopper } from "react-popper";
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
var Popup = ({
  isActive,
  refElement,
  layoutDependency,
  placement,
  zindex = 5,
  noPadding,
  ...props
}) => {
  const [active, setActive] = useState(isActive);
  const [ref, setRef] = useState(null);
  const [arrowRef, setArrowRef] = useState(null);
  const { attributes, styles, update } = usePopper(refElement, ref, {
    placement,
    modifiers: [{ name: "arrow", options: { element: arrowRef } }]
  });
  useEffect(() => {
    update && update();
  }, [...layoutDependency ?? []]);
  useEffect(() => {
    active !== isActive && setActive(isActive);
  }, [isActive, setActive]);
  if (!active && !isActive) {
    return null;
  }
  return /* @__PURE__ */ jsx(PopupPortal, { children: /* @__PURE__ */ jsx(
    "div",
    {
      ref: setRef,
      className: classNames(!noPadding && "p-2"),
      style: {
        opacity: active ? 1 : 0,
        zIndex: zindex,
        ...styles.popper
      },
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          ...props,
          ...attributes.popper,
          className: classNames("popper-box", props.className),
          style: {
            position: "relative",
            ...props.style
          },
          children: [
            props.children,
            /* @__PURE__ */ jsx(
              "div",
              {
                className: "popper-arrow",
                ref: setArrowRef,
                style: styles.arrow
              }
            )
          ]
        }
      )
    }
  ) });
};

export {
  Popup
};
